import React from 'react';
import './css/credentials.css';

export default function Credentials() {
	return (
		<section className="credentials-section">
			<div className="credentials-section__header">
				<h2 className="credentials-section__title">Credentials of the Tax Principal</h2>
				<p className="credentials-section__intro">
					A strong foundation in tax, accounting, and financial leadership built across regulated and
					commercial sectors.
				</p>
			</div>
			<div className="credentials-section__grid">
				<div className="credentials-card credentials-card--highlights">
					<h3>Qualifications</h3>
					<ul className="credentials-list">
						<li>Authorised tax agent registered with Inland Revenue Department (IRD)</li>
						<li>A Professional Accountant holding an MBA in Finance</li>
						<li>A Certified Tax Advisor conferred by the Institute of Chartered Accountants of Sri Lanka.</li>
						<li>A Finalist of the Institute of Chartered Accountants of Sri Lanka</li>
					</ul>
				</div>
				<div className="credentials-card credentials-card--summary">
					<h3>Experience</h3>
					<p>
						Phenomenally analytical and business intelligent Senior Financial/ Accounting Management
						Professional, with experience in multi-national companies comprising IT/ Testing Lab/ Retail/
						Engineering/ Office Automation industries, and also performing auditing in Manufacturing/
						Banking/ Trading/ Hospitality/ Etc., acquiring 25+ years of expertise in formulating/
						executing fiscal/ business strategies and tactics to attain corporate objectives, playing an
						integral role in the company&apos;s business direction to sustainable profitability/ growth, and
						steering financial operations effectively/ efficiently to meet and surpass business objectives
						via continuously collaborating with other departments.
					</p>
				</div>
			</div>
		</section>
	);
}
